import { Directive, ElementRef, Renderer2, Input, OnChanges } from "@angular/core";

@Directive({
	selector: "[hidePortfolioValue]",
	standalone: false
})
export class HidePortfolioDirective implements OnChanges {
	@Input() isHideActive: boolean = true;

	constructor(
		private el: ElementRef,
		private renderer: Renderer2
	) {}

	public ngOnChanges(): void {
		this.updateStyle();
	}

	private updateStyle(): void {
		if (this.isHideActive) {
			this.renderer.setStyle(this.el.nativeElement, "filter", "blur(12px)");
		} else {
			this.renderer.removeStyle(this.el.nativeElement, "filter");
		}
	}
}
